<template>
  <button
    type="button"
    class="ui-tab-button"
    :class="{ active, disabled }"
    :aria-selected="String(active)"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'UiTabButton',
  inheritAttrs: false,
  props: {
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
</script>
